import { useId } from "react";
import css from "./Password.module.css";
import { useLanguage } from "../LanguageProvider/LanguageProvider";

export default function PasswordField() {
  const { language } = useLanguage();
  const translations = {
    en: {
      greeting: "Password",
    },
    uk: {
      greeting: "Пароль",
    },
  };
  const translation = {
    en: {
      greeting: "The password should contain at least 18 characters",
    },
    uk: {
      greeting: "Пароль має містити не менше 18 символів",
    },
  };
  const passwordHintId = useId();
  return (
    <div className={css.item}>
      <label className={css.text}>
        {translations[language]?.greeting}:
        <input type="password" aria-describedby={passwordHintId} />
      </label>
      <p className={css.text} id={passwordHintId}>
        {translation[language]?.greeting}
      </p>
    </div>
  );
}
